/**
 * Highland Design Tokens
 *
 * Centralised design tokens for layout, spacing, radii, shadows, and transitions.
 * Wire these into the MUI theme via styleOverrides.
 */

// =============================================================================
// LAYOUT
// =============================================================================
export const DRAWER_WIDTH = 260;
export const APPBAR_HEIGHT_MOBILE = 56;
export const APPBAR_HEIGHT_DESKTOP = 64;

// =============================================================================
// BORDER RADIUS
// =============================================================================
export const RADIUS_SM = 4;   // chips
export const RADIUS_MD = 8;   // cards, papers, buttons, tables
export const RADIUS_LG = 12;  // modals

// =============================================================================
// SHADOWS
// =============================================================================
export const SHADOW_CARD_LIGHT = '0 1px 3px rgba(0,0,0,0.1)';
export const SHADOW_CARD_DARK = '0 1px 3px rgba(0,0,0,0.3)';
export const SHADOW_STAT_CARD = 'rgba(37, 55, 70, 0.08) 0px 2px 12px';
export const SHADOW_STAT_CARD_HOVER = '0 4px 16px rgba(37, 55, 70, 0.12)';

// =============================================================================
// SPACING (8px base)
// =============================================================================
export const SPACING_XS = 4;
export const SPACING_SM = 8;
export const SPACING_MD = 16;
export const SPACING_LG = 24;
export const SPACING_XL = 32;

// =============================================================================
// TRANSITIONS
// =============================================================================
export const TRANSITION_FAST = '150ms';
export const TRANSITION_NORMAL = '300ms';
export const EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

// =============================================================================
// FOCUS
// =============================================================================
export const FOCUS_RING_WIDTH = '2px';
export const FOCUS_RING_OFFSET = '2px';
export const FOCUS_RING_COLOUR = '#ed8b00';
